export default {
    '--full-color': '#373c3f',
    '--light-color': '#373c3f99',
    '--main-content-grid': '#F2F2F2',
    '--title-color':'rgba(0, 0, 0, 0.87)',
    '--icon-color': '#3d3f3f',
    '--grid-bg-color': 'rgb(68 68 68 / 10%)',
    '--text-input-bg-color': 'rgba(217,217,217,0.53)',
    '--avatar-background': 'linear-gradient(to right, #373c3f99, #373c3f)',
    '--reserve-background': 'linear-gradient(234deg, #3d3f3f 20%, #3d3f3f 35%)',
    '--icon-theme-filter': 'invert(40%) sepia(10%) saturate(10%) hue-rotate(180deg) brightness(94%) contrast(115%)',
    '--login-layout-background': 'linear-gradient(234deg, #3d3f3f 20%, #3d3f3f 35%)',
    '--lbl-focused-color': '#202425',
    '--focused-fieldset-color': 'rgba(32,36,37,0.5)',
    '--input-border-error-color': '#a92213',
    '--checkbox-color': '#323238',
    '--color-white': '#ffffff',
    '--txt-disabled': '#ffffff',
    '--txt-success': '#3d3f3f',
    '--txt-error': 'rgba(255,125,98,0.7)',
    '--disabled-bg': 'rgba(255,86,86,0.03)',
    '--txt-default': '#797979',
    '--link-color': '#3d3f3f',
    '--txt-gray-color': 'rgba(182, 182, 182, 1)',
    '--active-box-background': 'linear-gradient(180deg, #323238 0%, #161616 100%)',
    '--scrollbar-bg': 'linear-gradient(200deg, #323238, #161616)',
    '--active-item-background-color': 'rgba(121,121,121,0.15)',
    '--input-number-border-color': 'rgba(171,171,171,0.5)',
    '--input-number-focused-border-color': '#9d9d9d',
    '--grid-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--card-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--btn-bg-hover': 'rgba(89,89,89,0.8)',
    '--btn-success-background': 'linear-gradient(273.72deg, #3d3f3f 5.88%, #3d3f3f 128.9%)',
    '--btn-success-border-color': '#7e7e7e',
    '--btn-gray-background-color': '#a4a4a4',
    '--btn-gray-border-color': '#aaaaaa',
    '--btn-disabled-border-color': '#e8e8e8',
    '--tab-background': 'linear-gradient(180deg, #3d3f3f 0%, #3d3f3f 100%)',
    '--tab-indicator-background': 'transparent',
    '--tab-shadow': '0 4px 8px 1px rgba(85, 178, 153, 0.08)',
    '--btn-shadow': '0 4px 18px 1px rgba(87, 179, 182, 0.51)',
    '--card-shadow': '0 4px 6px 0 rgba(148, 148, 148, 0.31)',
    '--input-background-color': '#F2F2F2',
    '--select-border-color': 'rgba(89,89,89,0.8)',
    '--select-text-color': 'rgba(0,0,0,1)',
    '--select-bg-color': 'rgba(236,234,234,0.9)',
    '--loading-color': '#323238',
    '--redial-gradient': '#373c3f',
}